import { api } from './index';

// Devise scopes of the mobile-app accounts whose password is created or reset from the web.
export type PasswordScope = 'caregiver' | 'representative';

export interface PasswordForm {
  password: string;
  passwordConfirmation?: string;
  resetPasswordToken?: string;
}

export function passwordsApi(scope: PasswordScope) {
  const basePath = `/${scope}s/password`;

  return {
    create(email: string) {
      return api({
        method: 'post',
        url: basePath,
        data: { [scope]: { email } },
      }).then(response => response.data);
    },
    update(form: Partial<PasswordForm>) {
      return api({
        method: 'put',
        url: basePath,
        data: { [scope]: form },
      }).then(response => response.data);
    },
  };
}
